import React from 'react';
import { MasterAdminGovernance } from '../organisms';
import { SettingsTemplate } from '../templates';

export function MasterAdminGovernancePage() {
  return (
    <SettingsTemplate>
      <MasterAdminGovernance />
    </SettingsTemplate>
  );
}
